export default "__VITE_ASSET__Bf1QSt$x__"